import { Controller } from "@hotwired/stimulus"

const SESSION_KEY = "logoAnimationPlayed"

/**
 * Splash overlay: logo zooms out (1.3 → 1), then overlay fades out and is removed.
 * Runs once per browser session; skipped on subsequent navigations until tab/window is closed.
 */
export default class extends Controller {
  static targets = ["logo"]

  static values = {
    logoDuration: { type: Number, default: 800 },
    fadeDuration: { type: Number, default: 400 }
  }

  connect() {
    if (sessionStorage.getItem(SESSION_KEY) === "true") {
      this.element.remove()
      return
    }

    this.logoEl = this.hasLogoTarget ? this.logoTarget : this.element.querySelector(".splash-logo")
    if (!this.logoEl) return

    this.element.classList.remove("splash-overlay--pending")

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.logoEl.classList.add("splash-logo--animate")
      })
    })

    const logoMs = this.logoDurationValue
    const fadeMs = this.fadeDurationValue

    this.fadeTimeout = window.setTimeout(() => {
      sessionStorage.setItem(SESSION_KEY, "true")
      this.element.classList.add("splash-overlay--fade-out")
    }, logoMs)

    this.removeTimeout = window.setTimeout(() => {
      this.element.remove()
    }, logoMs + fadeMs)
  }

  disconnect() {
    if (this.fadeTimeout) window.clearTimeout(this.fadeTimeout)
    if (this.removeTimeout) window.clearTimeout(this.removeTimeout)
  }
}
